export const BACKGROUND_COLORS = {
  blue: {
    id: "blue" as const,
    labelKey: "settings.backgroundColor.blue",
    className: "deck-bg-blue",
    chipColor: "#dbeafe",
    isDark: false,
  },
  pink: {
    id: "pink" as const,
    labelKey: "settings.backgroundColor.pink",
    className: "deck-bg-pink",
    chipColor: "#fbcfe8",
    isDark: false,
  },
  yellow: {
    id: "yellow" as const,
    labelKey: "settings.backgroundColor.yellow",
    className: "deck-bg-yellow",
    chipColor: "#fef08a",
    isDark: false,
  },
  green: {
    id: "green" as const,
    labelKey: "settings.backgroundColor.green",
    className: "deck-bg-green",
    chipColor: "#bbf7d0",
    isDark: false,
  },
  purple: {
    id: "purple" as const,
    labelKey: "settings.backgroundColor.purple",
    className: "deck-bg-purple",
    chipColor: "#d8b4fe",
    isDark: false,
  },
  gray: {
    id: "gray" as const,
    labelKey: "settings.backgroundColor.gray",
    className: "deck-bg-gray",
    chipColor: "#d1d5db",
    isDark: false,
  },
  midnight: {
    id: "midnight" as const,
    labelKey: "settings.backgroundColor.midnight",
    className: "deck-bg-midnight",
    chipColor: "#1e3a5f",
    isDark: true,
  },
  charcoal: {
    id: "charcoal" as const,
    labelKey: "settings.backgroundColor.charcoal",
    className: "deck-bg-charcoal",
    chipColor: "#2d2d2d",
    isDark: true,
  },
} as const;

export type BackgroundColor = keyof typeof BACKGROUND_COLORS;
export const DEFAULT_BACKGROUND_COLOR: BackgroundColor = "midnight";

export function getBackgroundColorClass(color: BackgroundColor): string {
  return (
    BACKGROUND_COLORS[color]?.className ?? BACKGROUND_COLORS[DEFAULT_BACKGROUND_COLOR].className
  );
}

export function getBackgroundColorList() {
  return Object.values(BACKGROUND_COLORS);
}
